<section class="row">
	<ng-content></ng-content>
	<section class="col-20">
		<div class="chart-wrapper">
			<div class="chart-title-section">
				<h3 class="text-16-bold text-uppercase" data-cy="ate-indicator-column-chart-title">{{ sectionTitle }}</h3>
			</div>
			<div class="inner-chart-wrapper">
				<div class="left-content-wrapper">
					<div class="chart-focus-value">
						<span class="focus-value-title text-36-bold color-secondary" data-cy="ate-indicator-column-chart-focus-value">{{ portfolioValue }}</span>
						<div class="temp-wrap">
							<div class="square"></div>
							<span
								class="text-14 color-secondary"
								[attr.title]="portfolioName"
								[forcedLineBreak]="portfolioName"
								[maxCharsPerLine]="20"
								data-cy="ate-indicator-column-chart-legend"
							></span>
						</div>
					</div>
					<div *ngIf="showPeerComparison" class="chart-median-value">
						<span class="median-value-title text-18-bold color-secondary">{{ medianValue }}</span>
						<div class="temp-wrap">
							<div class="line">-</div>
							<span class="text-14 text-uppercase color-secondary" dcrHTMLKey="CHART_MEDIAN">Peer Group Median</span>
						</div>
					</div>
				</div>
				<div class="chart-container">
					<bfa-chart type="indicatorColumnChart" [data]="data" [data-index]="selectedPortfolioIndex" [customAttributes]="customAttributes"></bfa-chart>
				</div>
			</div>

			<div *ngIf="showPeerComparison" class="row margin-bottom-20">
				<div class="col-24">
					<a class="text-16-bold cta-link-icon" (click)="redirectToPeerComparison()">
						<icon type="wrench"></icon> <span dcrHTMLKey="CAP_LINK">Launch Peer Comparison</span>
					</a>
				</div>
			</div>
			<div *ngIf="showDisclaimers" class="text-14" [innerHTML]="disclaimer"></div>
			<div *ngIf="showDisclaimers" class="text-14" [innerHTML]="disclaimer2"></div>
		</div>
	</section>
</section>
